import React from 'react';
import { CalendarCheckIcon, PackageIcon, SparklesIcon, UsersIcon } from 'lucide-react';
import { equipment, facilities } from '../../data/loisirs';
export function BookingServices() {
  return <div className="mt-14 grid gap-8 lg:grid-cols-2 lg:gap-10" data-id="element-1343" data-mp="1woeauoi30z1m">
      <section aria-labelledby="spaces-title" data-id="element-1344" data-mp="1wlrtxy9ax76q">
        <h2 id="spaces-title" className="text-2xl font-extrabold tracking-tight text-ville-navy" data-id="element-1345" data-mp="21m63jkqjwp6v">
          Book a space
        </h2>
        <p className="mt-1 text-[15px] text-slate-600" data-id="element-1346" data-mp="2pdbgns53x3dh">Halls, gymnasiums, fields and rinks.</p>

        <p className="mt-4 flex items-start gap-2 rounded-2xl bg-ville-indigo-soft px-4 py-3 text-sm text-ville-navy" data-id="element-1347" data-mp="2tdlnf70q3xte">
          <SparklesIcon className="mt-0.5 h-4 w-4 shrink-0 text-ville-indigo" aria-hidden="true" data-id="element-1348" data-mp="2fggmflfv9p50" />
          “I am looking for a hall for 20 people on Saturday afternoon.” — here are the spaces ATNA suggests.
        </p>

        <ul className="mt-4 space-y-3" data-id="element-1349" data-mp="18y0g2q844m3c">
          {facilities.map(facility => <li key={facility.id} className="flex flex-wrap items-center gap-4 rounded-2xl border border-slate-200 bg-white px-5 py-4" data-id="element-1350" data-mp="18w77h5dxvrsp">
              <div className="min-w-0 flex-1" data-id="element-1351" data-mp="3k3fp89jsla4h">
                <p className="font-bold text-ville-navy" data-id="element-1352" data-mp="3k4qqo2prm5sf">{facility.name}</p>
                <p className="mt-0.5 text-sm text-slate-500" data-id="element-1353" data-mp="1ykp7ujpiz4p">
                  {facility.place} · {facility.availability}
                </p>
                <p className="mt-1 flex items-center gap-1.5 text-sm text-slate-500" data-id="element-1354" data-mp="3t5x6e9klbckm">
                  <UsersIcon className="h-4 w-4" aria-hidden="true" data-id="element-1355" data-mp="awenhb1182ui" />
                  {facility.capacity}
                </p>
              </div>
              <div className="text-right" data-id="element-1356" data-mp="kokbyas2s24y">
                <p className="font-extrabold text-ville-navy" data-id="element-1357" data-mp="kniwlu410thf">{facility.price}</p>
                <button type="button" className="mt-2 rounded-full bg-ville-navy px-4 py-2 text-sm font-bold text-white transition-transform duration-150 ease-ville hover:-translate-y-0.5 focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-indigo focus-visible:ring-offset-2" data-id="element-1358" data-mp="fq91bxtyhnlo">
                  Book
                </button>
              </div>
            </li>)}
        </ul>

        <p className="mt-3 flex items-center gap-2 text-xs text-slate-500" data-id="element-1359" data-mp="11on2h45812hc">
          <CalendarCheckIcon className="h-4 w-4" aria-hidden="true" data-id="element-1360" data-mp="16orn96d5wjdd" />
          Once confirmed, the booking is added to your digital card and the invoice to My Profile.
        </p>
      </section>

      <section aria-labelledby="equipment-title" data-id="element-1361" data-mp="1geky255hcugk">
        <h2 id="equipment-title" className="text-2xl font-extrabold tracking-tight text-ville-navy" data-id="element-1362" data-mp="1gdrnet3ehkt5">
          Rent equipment
        </h2>
        <p className="mt-1 text-[15px] text-slate-600" data-id="element-1363" data-mp="1pezlba208jmp">Sports gear and community equipment.</p>

        <ul className="mt-4 space-y-3" data-id="element-1364" data-mp="1ue2fu0kcz7gf">
          {equipment.map(item => <li key={item.id} className="flex flex-wrap items-center gap-4 rounded-2xl border border-slate-200 bg-white px-5 py-4" data-id="element-1365" data-mp="1udkdcm73rx02">
              <span className="grid h-11 w-11 shrink-0 place-items-center rounded-xl bg-slate-100 text-ville-navy" aria-hidden="true" data-id="element-1366" data-mp="1ijk4gisig">
                <PackageIcon className="h-5 w-5" data-id="element-1367" data-mp="3om6db1xdrqq2" />
              </span>
              <div className="min-w-0 flex-1" data-id="element-1368" data-mp="3jvhjhfy8ahnr">
                <p className="font-bold text-ville-navy" data-id="element-1369" data-mp="3jufxwhjl6crs">{item.name}</p>
                <p className="text-sm text-slate-500" data-id="element-1370" data-mp="3evbnxoou8b0e">
                  {item.detail} · {item.availability}
                </p>
              </div>
              <div className="text-right" data-id="element-1371" data-mp="39uxdjzzrkoz7">
                <p className="font-extrabold text-ville-navy" data-id="element-1372" data-mp="bfxtcpsutfcx">{item.price}</p>
                <button type="button" className="mt-2 rounded-full border border-ville-navy px-4 py-2 text-sm font-bold text-ville-navy transition-colors duration-150 ease-ville hover:bg-ville-navy hover:text-white focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-indigo focus-visible:ring-offset-2" data-id="element-1373" data-mp="6gbfqf945x3l">
                  Book
                </button>
              </div>
            </li>)}
        </ul>

        <p className="mt-3 text-xs text-slate-500" data-id="element-1374" data-mp="2h8mgv0fa387o">
          Show your digital card when you pick it up.
        </p>
      </section>
    </div>;
}